/**
 * Cascade Explorer page - full-page cascade visualization.
 */

import { useParams, Link } from 'react-router-dom';
import { useCascade } from '@/hooks/useAnalytics';
import { LoadingSpinner } from '@/components/ui/loading';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useState } from 'react';
import { PlacementCascade } from '@/pages/placements/tabs/cascade';
import './cascade-explorer.scss';

export function CascadeExplorer() {
  const { placementId } = useParams<{ placementId: string }>();

  if (!placementId) {
    return (
      <div className="text-center py-12">
        <p className="of-text-muted">Placement ID required</p>
        <Link to="/reports/top-sparks">
          <Button variant="primary" style={{ marginTop: 'var(--of-space-4)' }}>
            Back to Reports
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="cascade-explorer">
      <div className="cascade-explorer__header">
        <Link to="/reports/top-sparks">
          <Button variant="secondary">
            <ArrowLeft style={{ width: '1rem', height: '1rem', marginRight: '0.5rem' }} />
            Back to Reports
          </Button>
        </Link>
        <div>
          <h1 className="h1">Cascade Explorer</h1>
          <p className="subtitle">Placement: {placementId}</p>
        </div>
      </div>
      <PlacementCascade placementId={placementId} />
    </div>
  );
}

